export default __webpack_public_path__ + "static/media/spider_man_hd_spider_man_no_way_home-1-scaled.f12f3867.jpg";